// extracted by mini-css-extract-plugin
module.exports = {"root":"v_bJ","full-width":"v_cj","fullWidth":"v_cj"};